import { createFileRoute } from '@tanstack/react-router';

import { useSearchParams } from '@/lib/compat/navigation';
import {
  McpConsentContent,
  McpConsentRefused,
} from '@/screens/oauth/mcp-consent/McpConsentContent';

export const Route = createFileRoute('/_app/oauth/mcp-consent/')({
  component: McpConsentRoute,
});

function McpConsentRoute() {
  const params = useSearchParams();
  const requestId = params.get('request');

  if (!requestId) {
    return <McpConsentRefused reason={params.get('error')} />;
  }
  return <McpConsentContent requestId={requestId} />;
}
